import { useLocation } from 'react-router-dom';
import { FlexGrid, useThemeProvider } from '@albo-ui/core';
import { LandingWelcome } from '../../components-quick-win/landing-welcome';
import { SignUpForm } from '../../components-quick-win/sign-up-form';
import { FaTimes } from 'react-icons/fa';
import { IconContainer } from './style';
import { landingPageUrl } from '../../const';

export const SignUp = () => {
  const { theme } = useThemeProvider();
  const location = useLocation();
  const owner = new URLSearchParams(location.search).get('owner') ?? "";

  const onCloseClick = () => {
    window.open(landingPageUrl, '_self');
  };

  return (
    <FlexGrid
      container
      fullHeight
      fullWidth
      style={{ minHeight: '100vh', height: 'auto', backgroundColor: 'white' }}
    >
      <FlexGrid item flex='0.4'>
        <LandingWelcome />
      </FlexGrid>
      <FlexGrid
        item
        container
        flex='0.6'
        direction='column'
        style={{ padding: `${theme.spacesPx[4]} ${theme.spacesPx[10]} ` }}
        spacing={3}
      >
        <FlexGrid item style={{ marginLeft: 'auto' }}>
          <IconContainer onClick={onCloseClick}>
            <FaTimes size='20px' color={theme.colors.primary} />
          </IconContainer>
        </FlexGrid>
        <FlexGrid item>
          <SignUpForm obOwner={owner}/>
        </FlexGrid>
      </FlexGrid>
    </FlexGrid>
  );
};
